import React from "react";

const NotAuthorized = () => {
    return(
        <div className="container mt-5">
            <div className="alert alert-danger">
                <h4>Access Denied</h4>
                <p>You don't have permission to access this page.</p>
            </div>
        </div>
    );
};

export default NotAuthorized;